class EventSearchService {
  static search = async (values, page = 0) => {
    const parameters = {
      page,
    };

    Object.keys(values).forEach((key) => {
      if (
        key === "search" ||
        key === "day" ||
        key === "month" ||
        key === "year"
      ) {
        parameters[key] = values[key];
      } else {
        parameters[key] = [values[key]];
      }
    });

    const response = await fetch("/api/publiq/search", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(parameters),
    });

    const json = await response.json();

    return {
      results: json.events,
      pagination: {
        currentPage: json.page,
        total: json.totalItems,
        totalPages: json.pages,
      },
    };
  };
}

export default EventSearchService;
